var SurveyViewService = require('../survey-service');

var SurveyService = function() {
  this.triggerSurvey = function(blockView){
    var url = SurveyViewService.surveyUrl(blockView.model.get('slug'), blockView.model.get('return_hash'));
    if(url === undefined){
      console.warn("No Survey url");
      return;
    }
    else{
      setTimeout(_.bind(function(){
        Chaplin.mediator.publish('window:navigate', url);
      }, this), 2000);
    }
  };

  this.userHasCompletedSurvey = function(courseSlug){
    return !!SurveyViewService.getActivityProgressForSlug(courseSlug);
  };

  this.getSurvey = function(blockView){
    blockView.model.get('survey').fetch({
      error: function(err) {
        console.error("Error fetching survey: ", err);
      },
      success: function() {
        blockView.model.get('survey').initResponseSet({
            success: (responseSet) => {
              blockView.model.set('responseSet', responseSet);
              // sections is not set on the survey model for some reason
              // this has to be handled here or in the template
              blockView.model.get('survey').set('sections', blockView.model.get('survey').sections);
              blockView.render();
            }
          }
        );
      }
    });
  };

  this.saveSurveyResponse = function(blockView, dataset){
    blockView.model.get('responseSet').answerQuestion(...Object.values(dataset));
    blockView.model.get('responseSet').save();
  };
};

module.exports = new SurveyService();
